<template>
    <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <v-row class="titleMobile"
      :style="{gap: '1rem', marginLeft: '1rem !important'}">
        <v-btn
          class="back"
          dark
          icon
          to="/utils"
        >
          <v-icon
          :style="{color: '#27846d !important', fontSize: '34px'}"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
        <h2> {{ $t('views.utils.qr.title') }} </h2>
      </v-row>
        <v-container class="mt-3 generateqr-container" fluid>
          <v-row>
            <p> {{ $t('views.utils.qr.description') }} </p>
          </v-row>
          <v-row justify="center" class="mb-2">
            <v-col cols="12" sm="9" md="9" class="text-center textMobile">
              <v-textarea
                v-model="inputQr"
                label="Genera tu código QR"
                placeholder="Ejemplo: https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/"
                rows="1"
                auto-grow
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="3" md="3" class="text-center btnMobile">
              <v-btn
                class="generateqr-btn"
                color="primary"
                block
                @click="()=> generateQR()"
              >
              Generar
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-show="showBtnRetry" class="imgqr-row">
            <div id="qrcode"></div>
          </v-row>
          <v-row v-if="showBtnRetry" justify="center">
            <v-col cols="12" class="text-center btnMobile">
              <div class="ki-actions btnGroupShare col-auto px-0 pt-0 pb-0"
                :style="{ borderColor: 'rgb(39, 132, 109)'  }">
                <v-btn
                  class="v-btn v-btn--icon v-btn--round
                  theme--light v-size--default iconHover"
                  color="primary--text blue-grey lighten-4 donwload"
                  dark
                  icon
                  @click="downloadQR"
                  >
                  <v-icon
                    :style="{color:'#757575'}"
                  >
                    mdi-download
                  </v-icon>
                </v-btn>
                <v-spacer v-if="!isMobile" class="spacer"></v-spacer>
                <v-btn
                  v-if="!isMobile"
                  class="v-btn v-btn--icon v-btn--round
                  theme--light v-size--default iconHover"
                  color="primary--text blue-grey lighten-4"
                  dark
                  icon
                  @click="copyQR"
                  >
                  <v-icon
                    :style="{color:'#757575'}"
                  >
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="showBtnRetry">
            <v-col cols="12" class="text-center btnClear">
              <v-btn
                @click="clear"
                plain
                >
                <v-icon left>mdi-refresh</v-icon>
                {{ $t('views.utils.qr.otherQr') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>

  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import QRCode from 'easyqrcodejs';
import FileSaver from 'file-saver';

const logoJuntaResponsive = '/img/logo-junta-responsive.svg';

export default {
  data() {
    return {
      inputQr: '',
      imgQr: '',
      loading: false,
      openDialog: false,
      showBtnRetry: false,
    };
  },
  computed: {
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
  },
  methods: {
    generateQR() {
      this.clearQr();
      this.showBtnRetry = false;
      // limpiar contenedor si ya existe QR
      const container = document.getElementById('qrcode');
      if (!container) return;
      container.innerHTML = '';

      // Opciones del QR
      const options = {
        text: this.inputQr,
        width: 200,
        height: 200,
        // Colores
        colorDark: '#0b8457', // color de los módulos (oscuro)
        colorLight: '#ffffff', // fondo
        // Corrección de errores alta para permitir logo en el centro
        correctLevel: QRCode.CorrectLevel.H,
        // Logo centrado (puede ser ruta pública o import)
        logo: logoJuntaResponsive,
        logoWidth: 80,
        logoHeight: 80,
        // Opciones de fondo del logo
        logoBackgroundColor: '#ffffff',
        logoBackgroundTransparent: true,
      };
      setTimeout(() => {
        this.qrInstance = new QRCode(container, options);
      }, 500);
      this.showBtnRetry = true;
    },
    downloadQR() {
      const canvas = document.querySelector('#qrcode canvas');
      if (canvas) {
        const url = canvas.toDataURL('image/png');
        if (this.isMobile) {
          this.sendQrToFlutter(url);
        }
        FileSaver.saveAs(url, 'qr-code.png');
      } else {
        console.log('No se encontró el canvas del QR');
      }
    },
    sendQrToFlutter(data) {
      if (this.$flutterPort) {
        this.$flutterPort.postMessage(
          JSON.stringify({
            type: 'save_qr',
            payload: data,
            filename: 'qr_code.png',
          }),
        );
      } else {
        console.log('Flutter port no disponible');
      }
    },
    clear() {
      this.inputQr = '';
      this.imgQr = '';
      this.showBtnRetry = false;
      this.clearQr();
    },
    clearQr() {
      const qrContainer = document.getElementById('qrcode');
      if (qrContainer) {
        qrContainer.innerHTML = '';
        this.qrInstance = null;
      }
    },
    async copyQR() {
      // Busca el canvas generado por easyqrcodejs
      const canvas = document.querySelector('#qrcode canvas');
      if (canvas) {
        // Convierte el canvas a blob PNG
        canvas.toBlob(async (blob) => {
          try {
            await navigator.clipboard.write([
              new window.ClipboardItem({ 'image/png': blob }),
            ]);
            console.error('Imagen QR copiada al portapapeles');
          } catch (err) {
            console.error(err, 'No se pudo copiar la imagen al portapapeles');
          }
        }, 'image/png');

        this.$store.dispatch('messages/createNotificationMessage', {
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('views.utils.qr.qrCopiado'),
          timeout: this.$getConst('notifications.timeout'),
        });
      } else {
        // Si es un <img>, puedes copiar el src como texto base64, pero no como imagen directa
        console.error('No se encontró el canvas del QR');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.generateqr-container {
  width: 100%;
  background: #fff;
  padding: 2rem !important;
  min-width: 100% !important;
}
.generateqr-btn {
  color: #fff !important;
  font-weight: 600;
  box-shadow: none;
  margin-top: 16px !important;
}
.generateqr-btn .v-icon {
  color: #fff !important;
}
.v-btn--block{
    min-width: 100px !important;
    max-width: 100px !important;
}
/* PT-PR-PB-PL */
.btnGenerateqr{
  padding: 0 0 0 1rem !important;
}
.imgqr-row{
  display: flex;
  justify-content: center;
  margin-top: 0px !important;
}
.donwload{
  margin-right: 1rem !important;
}
.btnGroupShare{
  display: flex;
  padding-top: 12px !important;
  justify-content: center;
}
.spacer{
  width: 1rem !important;
  max-width: 1rem !important;
}
.ki-actions {
  position: relative;
  /*padding-top: 18px !important;*/

  > button {
    width: 42px !important;
    height: 42px !important;
    border-radius: 50%;
    border-color: inherit;
    border-width: 2px;
    border-style: solid;
    background-color: white;

    &:last-child .ki-action-name.right {
      left: 100%;
      display: table;
      transform: translateX(-100%);
    }
  }

  .ki-action-name {
    pointer-events: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media screen and (max-width: 600px) {
    .v-btn--block{
        min-width: 100% !important;
        max-width: 100% !important;
    }
    .btnGenerateqr{
      padding: 0 0 0 0 !important;
    }
    .textMobile{
      padding-bottom: 0px !important;
    }
    .btnClear{
      padding-top: 0px !important;
    }
}
</style>
